import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { SALENG_GREEN_API_PROD, SALENG_SHOP_API_PROD, SALENG_SHOP_API_DEV } from "./../config";

const SALENG_GREEN_API = SALENG_GREEN_API_PROD
const SALENG_SHOP_API = SALENG_SHOP_API_PROD
const accessToken = localStorage.getItem('accessToken');

if (accessToken) {
    var decoded = jwtDecode(accessToken);
    console.log("decoded", decoded)
    var shopId = decoded.shopId
    var branchId = decoded.branchId
}

// Auth
export const loginShop = (payload) => {
    return axios.post(`${SALENG_SHOP_API}/auth/login`, payload, {
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': 'Bearer ' + token
        },
    })
};


// Categories
export const getCategories = (token) => {
    return axios.get(`${SALENG_GREEN_API}/categories`, {
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': 'Bearer ' + token
        },
    })
};


// Product
export const getProducts = () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
        console.error("No access token found");
        return Promise.reject("No access token");
    }

    try {
        const decoded = jwtDecode(accessToken);
        const shopId = decoded.shopId;
        return axios.get(`${SALENG_SHOP_API}/products/${shopId}`, {
            headers: {
                'Content-Type': 'application/json',
                // 'Authorization': 'Bearer ' + accessToken, // ถ้าต้องใช้
            },
        });
    } catch (error) {
        console.error("Failed to decode token", error);
        return Promise.reject("Invalid access token");
    }
}

export const createProduct = (payload) => {
    return axios.post(`${SALENG_SHOP_API}/products`, { ...payload, shopId: shopId }, {
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': 'Bearer ' + token
        },
    })
};

export const deleteProduct = (id) => {
    return axios.delete(`${SALENG_SHOP_API}/products/${shopId}/${id}`, {
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': 'Bearer ' + token
        },
    })
};

export const updateProduct = (id, payload) => {
    return axios.put(`${SALENG_SHOP_API}/products/${shopId}/${id}`, payload, {
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': 'Bearer ' + token
        },
    })
};


// Shop
export const getShop = (id) => {
    return axios.get(`${SALENG_SHOP_API}/shop/${id ?? shopId}`, {
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': 'Bearer ' + token
        },
    })
};

export const createShop = (payload, shopId) => {
    return axios.post(`${SALENG_SHOP_API}/shop`, { ...payload, shopId: shopId }, {
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': 'Bearer ' + token
        },
    })
};


// Branches
export const createBranch = (payload) => {
    return axios.post(`${SALENG_SHOP_API}/branches`, { ...payload, shopId: shopId }, {
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': 'Bearer ' + token
        },
    })
};

export const deleteBranch = (id) => {
    return axios.delete(`${SALENG_SHOP_API}/branches/${shopId}/${id}`, {
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': 'Bearer ' + token
        },
    })
};

export const updateBranch = (id, payload) => {
    return axios.put(`${SALENG_SHOP_API}/branches/${shopId}/${id}`, payload, {
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': 'Bearer ' + token
        },
    })
};


// Users
export const getUser = (id) => {
    return axios.get(`${SALENG_GREEN_API}/users/` + id, {
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': 'Bearer ' + token
        },
    })
};

export const createUser = (payload) => {
    return axios.post(`${SALENG_SHOP_API}/users`, { ...payload, shopId: shopId }, {
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': 'Bearer ' + token
        },
    })
};

export const deleteUser = (id) => {
    return axios.delete(`${SALENG_SHOP_API}/users/${shopId}/${id}`, {
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': 'Bearer ' + token
        },
    })
};

export const updateUser = (id, payload) => {
    return axios.put(`${SALENG_SHOP_API}/users/${shopId}/${id}`, payload, {
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': 'Bearer ' + token
        },
    })
};


// Transaction
export const getTransaction = (transactionId) => {
    return axios.get(`${SALENG_SHOP_API}/transaction/` + transactionId, {
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': 'Bearer ' + token
        },
    })
};

export const getBranchTransaction = () => {
    const decoded = jwtDecode(accessToken);
    const branchId = decoded.branchId;
    return axios.get(`${SALENG_SHOP_API}/transaction/branch/${branchId}`, {
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': 'Bearer ' + token
        },
    })
};

const generateBillNumber = (branchCode, lastNumber) => {
    const today = new Date();
    const datePart = today.toISOString().slice(0, 10).replace(/-/g, ""); // YYYYMMDD
    const newNumber = String(lastNumber + 1).padStart(3, "0");
    const formattedBranchCode = String(branchCode).padStart(2, "0");
    return `B${formattedBranchCode}-${datePart}-${newNumber}`;
};

export const createTransaction = async (payload) => {
    try {
        const transactionsResponse = await getBranchTransaction();
        const transactions = transactionsResponse.data.data;

        const billNumber = generateBillNumber(branchId, transactions.length);

        return axios.post(`${SALENG_SHOP_API}/transaction`, { ...payload, branchId: branchId, shopId: shopId, billNumber: billNumber }, {
            headers: {
                'Content-Type': 'application/json',
                // 'Authorization': 'Bearer ' + token
            },
        })
    } catch (error) {
        console.error("Error creating transaction:", error);
    }
};

export const getUserByPhone = (phoneNumber) => {
    return axios.get(`${SALENG_GREEN_API}/users/by-phone/` + phoneNumber, {
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': 'Bearer ' + token
        },
    })
};
export const addPointToUser = (id, body) => {
    return axios.post(`${SALENG_GREEN_API}/users/${id}/add-point`, { ...body }, {
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': 'Bearer ' + token
        },
    })
};
export const Upload = (formData) => {
    return fetch(`${SALENG_SHOP_API}/files`, {
        method: "POST",
        body: formData,
    });
};
